import {cn} from "@bem-react/classname";

export const cnLink = cn('Link');